// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3K-T1","loaderOuter":"PageOverlayLoader_loaderOuter__OQI4q"};